import e from"react";var l=e.createContext({selectedTab:0,setSelectedTab:null,kind:null,scale:null,noConditionalRendering:!1});export{l as default};
